import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading, true/false = result
  
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check localStorage for authentication state
        const isAdminAuthenticated = localStorage.getItem('adminAuthenticated');
        const loginTime = localStorage.getItem('adminLoginTime');
        const authToken = localStorage.getItem('auth_token');
        
        console.log('Auth check:', { isAdminAuthenticated, loginTime, hasToken: !!authToken });
        
        if (!isAdminAuthenticated || !loginTime) {
          console.log('No auth data in localStorage, redirecting to login');
          setIsAuthenticated(false);
          return;
        }
        
        // Check if login is less than 24 hours old (session timeout)
        const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
        const currentTime = Date.now();
        const timeSinceLogin = currentTime - parseInt(loginTime);
        
        if (timeSinceLogin > twentyFourHours) {
          console.log('Session expired, clearing auth');
          // Session expired
          localStorage.removeItem('adminAuthenticated');
          localStorage.removeItem('adminLoginTime');
          localStorage.removeItem('adminUid');
          localStorage.removeItem('auth_token');
          setIsAuthenticated(false);
          return;
        }
        
        // For now, trust localStorage if it's within the time limit
        console.log('Authentication successful via localStorage');
        setIsAuthenticated(true);
        
      } catch (error) {
        console.error('Auth check error:', error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);
  
  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="h-12 w-12 text-blue-600 animate-spin mx-auto mb-4" />
          <p className="text-xl text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }
  
  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Authenticated - render the protected component
  return children;
};

export default ProtectedRoute; 